import React from 'react';
import { AllhomesCheckboxList } from '@domain-group/fe-co-allhomes-checkbox-list';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-search-property-type.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesSearchPropertyType = _ref => {
  var _ref$propertyTypes = _ref.propertyTypes,
    propertyTypes = _ref$propertyTypes === void 0 ? [] : _ref$propertyTypes,
    _ref$selectedTypes = _ref.selectedTypes,
    selectedTypes = _ref$selectedTypes === void 0 ? [] : _ref$selectedTypes,
    className = _ref.className,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    _ref$onButtonClick = _ref.onButtonClick,
    onButtonClick = _ref$onButtonClick === void 0 ? () => {} : _ref$onButtonClick,
    _ref$embedded = _ref.embedded,
    embedded = _ref$embedded === void 0 ? false : _ref$embedded;
  return ___EmotionJSX("section", {
    className: className
  }, !embedded && ___EmotionJSX("div", {
    css: styles.title
  }, "Property Types"), ___EmotionJSX(AllhomesCheckboxList, {
    css: styles.container,
    available: propertyTypes.map(_ref2 => {
      var label = _ref2.label,
        value = _ref2.name;
      return {
        label,
        value
      };
    }),
    selected: selectedTypes,
    onChange: onChange,
    all: "none-is-all"
  }), !embedded && ___EmotionJSX("div", {
    css: styles.applyButton
  }, ___EmotionJSX(Button, {
    onClick: onButtonClick
  }, "Apply")));
};